import { TAccount } from '@helpers/Accounts/accounts.types';

import {
    TAccountFeatureMap,
    TSplitTestAssignments
} from '../AccountFeatureEvaluator/AccountFeatureEvaluator';
import { AccessPeriodBanner } from '../dashboardWidgets/accessPeriodBanner/AccessPeriodBanner';
import { CreditBuilderProgress } from '../dashboardWidgets/creditBuilderProgress/CreditBuilderProgress';
import { DashboardTitle } from '../dashboardWidgets/dashboardTitle/DashboardTitle';
import { InterestOnlyExtensionApprovedBanner } from '../dashboardWidgets/InterestOnlyExtensionApprovedBanner/InterestOnlyExtensionApprovedBanner';
import { LoanOverview } from '../dashboardWidgets/loanOverview/LoanOverview';
import { RepaymentsPanel } from '../dashboardWidgets/RepaymentsPanel/RepaymentsPanel';
import { TopupApprovedBanner } from '../dashboardWidgets/topupApprovedBanner/TopupApprovedBanner';
import { TopupEligibleBanner } from '../dashboardWidgets/topupEligibleBanner/TopupEligibleBanner';
import { TopupPendingBanner } from '../dashboardWidgets/topupPendingBanner/TopupPendingBanner';

type WidgetConfig = {
    id: string;
    component: React.ComponentType<{
        accountId: NonNullable<TAccount['account_id']>;
    }>;
    shouldShow: (
        features: TAccountFeatureMap,
        splitTests?: Partial<TSplitTestAssignments>
    ) => boolean;
};

export const WIDGET_REGISTRY: WidgetConfig[] = [
    {
        id: 'title',
        component: DashboardTitle,
        shouldShow: (features: TAccountFeatureMap) =>
            features.micro_loan ||
            features.micro_loan_plus ||
            features.interest_only_plus ||
            features.revenue_based_loan ||
            features.term_loan ||
            features.flexi_loan ||
            features.interest_only
    },
    {
        id: 'access_period_banner',
        component: AccessPeriodBanner,
        shouldShow: (features: TAccountFeatureMap) =>
            features.interest_only_plus
    },
    {
        id: 'topup_eligibility_banner',
        component: TopupEligibleBanner,
        shouldShow: (features: TAccountFeatureMap) =>
            (features.revenue_based_loan && features.topup_eligible) ||
            features.topup_eligible
    },
    {
        id: 'topup_approved_banner',
        component: TopupApprovedBanner,
        shouldShow: (features: TAccountFeatureMap) =>
            (features.revenue_based_loan && features.topup_approved) ||
            (features.topup_approved && !features.interest_only_plus) //do not show the banner for InterestOnlyPlus for DE
    },
    {
        id: 'topup_pending_banner',
        component: TopupPendingBanner,
        shouldShow: (features: TAccountFeatureMap) =>
            (features.revenue_based_loan && features.topup_pending) ||
            features.topup_pending
    },
    {
        id: 'interest_only_extension_banner',
        component: InterestOnlyExtensionApprovedBanner,
        shouldShow: (features: TAccountFeatureMap) =>
            features.interest_only_extension
    },
    {
        id: 'loan_overview',
        component: LoanOverview,
        shouldShow: (features: TAccountFeatureMap) =>
            features.micro_loan ||
            features.micro_loan_plus ||
            features.interest_only_plus ||
            features.revenue_based_loan ||
            features.term_loan ||
            features.flexi_loan ||
            features.interest_only
    },
    {
        id: 'credit_builder',
        component: CreditBuilderProgress,
        shouldShow: (features: TAccountFeatureMap) =>
            features.micro_loan || features.micro_loan_plus
    },
    {
        id: 'repayments_panel',
        component: RepaymentsPanel,
        shouldShow: (features: TAccountFeatureMap) =>
            features.micro_loan ||
            features.micro_loan_plus ||
            features.interest_only_plus ||
            features.revenue_based_loan ||
            features.term_loan ||
            features.flexi_loan ||
            features.interest_only
    }
];
